export function qsStringifyObject(obj?: object): string {
  if (!obj) {
    return '';
  }
  const jsonObj: Record<string, string> = {
    ...obj,
  };
  const params = new URLSearchParams();
  for (const key of Object.keys(jsonObj)) {
    params.set(key, jsonObj[key]);
    jsonObj[key] = JSON.stringify(jsonObj[key]);
  }
  return params.toString();
}

export function areSetsEqual(a: Set<any>, b: Set<any>) {
  return a.size === b.size && [...a].every((value) => b.has(value));
}
